module.exports = function() {
  return new Worker(__webpack_public_path__ + "static/js/CodeHighlight.worker_0f04.js");
};